module.exports = __webpack_public_path__ + "static/media/avatar.8b31df48.jpg";